export const Border = {
    sm: '1px',
    md: '1.5px',
    lg: '2px',
    xl: '3px'
}